type PaymentSuccessContent = {
  body: string;
  continueLabel: string;
  continuePath: string;
};

const DEFAULT_CONTINUE_PATH = "/discover";

const DEFAULT_CONTENT: PaymentSuccessContent = {
  body: "Thank you for your purchase. Your payment completed successfully.",
  continueLabel: "Continue",
  continuePath: DEFAULT_CONTINUE_PATH,
};

/** Add keys here as new paid products ship. Query: `/payment-success?product=<key>` */
const registry: Record<string, PaymentSuccessContent> = {
  default: DEFAULT_CONTENT,
  event_access_unlock: {
    body: "Thank you for your purchase. Your free event window no longer expires for this event — you keep full access for this night, not only chats where the other person had already paid.",
    continueLabel: "Continue to app",
    continuePath: DEFAULT_CONTINUE_PATH,
  },
  event_vip_unlock: {
    body: "Thank you for your VIP purchase. Liked you and full event access are unlocked for tonight.",
    continueLabel: "See who liked you",
    continuePath: "/liked-you",
  },
};

export const PAYMENT_UNLOCK_PENDING_BODY =
  "Your payment went through. Tap Restore access below to finish activating your purchase — you will not be charged again.";

function isSafeInternalPath(path: string): boolean {
  if (!path.startsWith("/") || path.startsWith("//")) {
    return false;
  }
  if (path.includes("://") || path.includes("\\")) {
    return false;
  }
  return true;
}

export function resolvePaymentSuccessNext(nextParam: string | null, fallbackPath: string): string {
  if (nextParam && isSafeInternalPath(nextParam)) {
    return nextParam;
  }
  return fallbackPath;
}

export function getPaymentSuccessContent(productParam: string | null): PaymentSuccessContent {
  const key = productParam?.trim() || "default";
  return registry[key] ?? DEFAULT_CONTENT;
}

export function resolvePaymentSuccessContinue(
  productParam: string | null,
  nextParam: string | null
): { label: string; path: string } {
  const base = getPaymentSuccessContent(productParam);
  return {
    label: base.continueLabel,
    path: resolvePaymentSuccessNext(nextParam, base.continuePath),
  };
}
